import Ark from './Ark'
import EventSpace from './EventSpace'
import InRun from './InRun'
import LargeVision from './LargeVision'
import LiftAndLearn from './LiftAndLearn'
import Main from './Main'
import Minivision from './Minivision'
import WFH from './WFH'
import WOW from './WOW'
import JLP from './JLP'
import EventSpace2 from './EventSpace2'

const Dashboards = [Ark, EventSpace, InRun, LargeVision, LiftAndLearn, Main, Minivision, WFH, WOW, JLP, EventSpace2]

export default Dashboards
